var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "px-4 my-1 hidden-md-and-down" },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.cardHeaders,
              "hide-actions": "",
              items: _vm.list
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _vm._l(props.item, function(propertyColumn, index) {
                        return !propertyColumn.ignore
                          ? _c(
                              "td",
                              { key: "property-column-" + index },
                              [
                                _vm._.get(propertyColumn, "value", false)
                                  ? [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(propertyColumn.value) +
                                          "\n          "
                                      )
                                    ]
                                  : _vm._l(
                                      _vm._.get(propertyColumn, "values", []),
                                      function(attr, index) {
                                        return _c(
                                          "v-flex",
                                          { key: "attribute-name-" + index },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(attr.name) + ":")
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(attr.value) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      }
                                    )
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.hasDriverSlot
                        ? _c(
                            "td",
                            [_vm._t("driver", null, { item: props.item })],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRequirementsSlot
                        ? _c(
                            "td",
                            [
                              _vm._t("requirements", null, { item: props.item })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "v-layout",
                            { attrs: { "align-center": "", column: "" } },
                            [_vm._t("action", null, { item: props.item })],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hidden-lg-and-up mt-4" },
        _vm._l(_vm.list, function(card, index) {
          return _c(
            "v-card",
            {
              key: "card-" + index,
              staticClass: "my-1",
              attrs: { xs12: "" },
              on: {
                click: function($event) {
                  return _vm.viewLoadDetail(card.humanId)
                }
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pa-1" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _vm._l(card, function(propertyColumn) {
                        return _c(
                          "div",
                          { key: "card-" + propertyColumn.Id },
                          [
                            propertyColumn.value
                              ? _c(
                                  "v-flex",
                                  {
                                    key: "card-property-column-" + index,
                                    staticClass: "mt-2"
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        staticClass:
                                          "caption font-weight-light",
                                        attrs: { "align-center": "" }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              size: "18",
                                              color: "primary"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(propertyColumn.icon) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(propertyColumn.value) +
                                              "\n                "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : propertyColumn.values
                              ? _vm._l(propertyColumn.values, function(
                                  lineProperty,
                                  index
                                ) {
                                  return _c(
                                    "v-flex",
                                    {
                                      key: "line-property-" + index,
                                      staticClass: "mt-2",
                                      attrs: { md3: "", sm4: "", xs12: "" }
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          staticClass:
                                            "caption font-weight-light",
                                          attrs: { "align-center": "" }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "18",
                                                color: "primary"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(lineProperty.icon) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(lineProperty.value) +
                                                "\n                  "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("v-flex")
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", "justify-center": "" } },
                    [_vm._t("driver", null, { item: card })],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", "justify-center": "" } },
                    [_vm._t("requirements", null, { item: card })],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        row: "",
                        wrap: "",
                        "justify-center": "",
                        "align-center": ""
                      }
                    },
                    [_vm._t("action", null, { item: card })],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-649e6ebe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-649e6ebe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheCard.vue
// module id = null
// module chunks = 